import { Link } from 'react-router-dom';

const reviews = [
  {
    text: '"Previously, I didn\'t really have any idea who my agent was but Cameron took the time to make sure I knew how to reach him and made me feel like I was part of his family. He also gave me a few tips on how to save even more money when I eventually add my teenage son to the policy."',
    author: 'Carey C.',
  },
  {
    text: '"The White Oak team were fantastic to work with! They were quick to respond and were able to get me set up with exactly what I needed for my business!"',
    author: 'Ryan H.',
  },
  {
    text: '"Working with Cameron was a great experience! He clearly explained my existing policy and showed me where I could do better. I appreciate the time he took to make sure I was well-informed regarding my home and auto policies. I would highly recommend Cameron and his team!"',
    author: 'Jackie A.',
  },
];

export default function Reviews() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0b2240] mb-3">
            Our Clients Rave About Us
          </h2>
          <p className="text-gray-500">
            Check out our reviews and see why you should work with our agency.
          </p>
        </div>

        {/* Review cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {reviews.map((review) => (
            <div
              key={review.author}
              className="bg-white border border-gray-100 shadow-sm rounded-lg p-8 flex flex-col gap-4"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-double-quotes-l text-3xl text-[#9cbde5]" />
              </div>
              <p className="text-gray-700 text-sm leading-relaxed italic flex-1">{review.text}</p>
              <div>
                <div className="flex gap-0.5 text-yellow-400 text-sm mb-1">
                  {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill" />)}
                </div>
                <p className="text-[#0b2240] font-bold text-sm">{review.author}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/about#reviews"
            className="border-2 border-[#0b2240] text-[#0b2240] hover:bg-[#0b2240] hover:text-white font-bold text-sm px-8 py-3.5 rounded-md transition-colors whitespace-nowrap"
          >
            Read More Reviews
          </Link>
          <a
            href="https://www.google.com"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#3072b7] hover:bg-[#0b2240] text-white font-bold text-sm px-8 py-3.5 rounded-md transition-colors flex items-center gap-2 whitespace-nowrap"
          >
            Read Our Google Reviews
            <i className="ri-google-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
